import { listAssignmentsResult } from '../deals/services/deals.service';
import { getDashboardDealsDataResult } from '../dashboard/services/dashboard.service';
import { listPaymentsResult, listExpensesResult, listInvoicesResult } from '../accounting/services/accounting.service';
import { listDocumentsResult } from '../documents/services/documents.service';
import { listCalendarEventsResult } from '../calendar/services/calendar.service';

const sources = [
  { id: 'assignments', label: 'Task', load: listAssignmentsResult },
  { id: 'deals', label: 'Affari', load: getDashboardDealsDataResult },
  { id: 'payments', label: 'Incassi', load: listPaymentsResult },
  { id: 'expenses', label: 'Uscite', load: listExpensesResult },
  { id: 'invoices', label: 'Fatture', load: listInvoicesResult },
  { id: 'documents', label: 'Documenti', load: listDocumentsResult },
  { id: 'calendarEvents', label: 'Calendario', load: listCalendarEventsResult },
];

export async function loadPartyActivity() {
  const results = await Promise.allSettled(sources.map((source) => source.load()));
  const data = {}, unavailable = [], available = {};
  results.forEach((result, index) => {
    const source = sources[index];
    const response = result.status === 'fulfilled' ? result.value : null;
    available[source.id] = response?.ok === true;
    if (!available[source.id]) {
      unavailable.push(source.label);
      return; // Never classify people as idle using cached or failed responses.
    }
    if (source.id === 'deals') Object.assign(data, response.data);
    else data[source.id] = source.id === 'documents' ? response.data.documents : response.data;
  });
  const complete = unavailable.length === 0;
  return { data, unavailable, ready: { tasks: available.assignments, deals: available.deals, overdue: complete, idle: complete } };
}
